/**
 * Created by cc
 * 头条渠道服务模块
 */
'use strict';
angular.module('productManageMentToutiaohaoServiceModule', [
    'productManageMentToutiaohaoAccountAddModule',
    'productManageMentEditToutiaohaoModule',
    'productManageMentSortToutiaohaoModule',
    'productManageMentShowRssMessageModule',
])
    .factory('productManageMentToutiaohaoService', ['$q', '$modal', 'trsHttpService', 'globleParamsSet',
        function($q, $modal, trsHttpService, globleParamsSet) {
            return {

                /**
                 * [AccountId description]获取微博操作权限
                 *
                 * @param  {[type]}  AccountId   [AccountId description]
                 * @param  {[type]}  classify   [classify description]
                 *
                 * @return  {[type]}   [return description]
                 */
                getRight: function(AccountId, classify) {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperKeyOftrill',
                        AccountId: AccountId,
                        Classify: classify
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                        .then(function(data) {
                            var right = {};
                            for (var i = 0; i < data.length; i++) {
                                right[data[i].OPERNAME.split('.')[2]] = true;
                            }
                            deffer.resolve(right);
                        });
                    return deffer.promise;
                },

                /**
                 * [item description]添加头条号账号
                 *
                 * @param  {[type]}  item   [item description] 要编辑的头条号帐号信息，新建不传
                 * @param  {[type]}  success   [success description] 完成后的回调函数
                 *
                 * @return  {[type]}   [return description]
                 */
                AccountAdd: function(item, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/productManageMent/toutiaohao/service/toutiaohaoAccountAdd/toutiaohaoAccountAdd_tpl.html',
                        windowClass: 'weibo-account-add',
                        backdrop: false,
                        resolve: {
                            item: function() {
                                return item;
                            }
                        },
                        controller: 'ProductManageMentToutiaohaoAccountAddCtrl'
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },

                /**
             * [edit description] 查看Rss地址
             * @return {[type]} [description]
             */
                RssFind: function(item) {
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/productManageMent/toutiaohao/service/showRssMessage/showRssMessage.html',
                        windowClass: 'tth-rss-find',
                        backdrop: false,
                        resolve: {
                            item: function() {
                                return item;
                            }
                        },
                        controller: 'productManageMentShowRssMessageCtrl'
                    });
                },

                /**
             * [edit description] 修改微博配置
             * @return {[type]} [description]
             */
                edit: function(item, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/productManageMent/toutiaohao/service/editToutiaohao/editToutiaohao_tpl.html',
                        windowClass: 'weibo-account-add',
                        backdrop: false,
                        resolve: {
                            item: function() {
                                return item;
                            }
                        },
                        controller: 'productManageMentEditToutiaohaoCtrl'
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                },

                /**
             * [sort description] 微博账号排序
             * @param  {[object]} item    [description] 微博账号
             * @param  {[Function]} success [description] 成功后的回调函数
             * @return {[type]}         [description]
             */
                sort: function(item, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/productManageMent/toutiaohao/service/sortToutiaohao/sortToutiaohao_tpl.html',
                        windowClass: 'productManageMent-weibo-sort',
                        backdrop: false,
                        resolve: {
                            item: function() {
                                return item;
                            }
                        },
                        controller: 'productManageMentSortToutiaohaoCtrl'
                    });
                    modalInstance.result.then(function(result) {
                        success(result);
                    });
                }
            };
        }]);
